import i18n from "../lang/i18n";
const validations = {
  name: {
    required: true,
    maxLength: 255
  },
  gradeScale: {
    required: true,
    format: {
      valid: value => /^.{1,2}$/.test(value.trim()),
      message: i18n.t("validation.this_field_must_be_less_than_3_characters")
    }
  },
  gpa: {
    required: true,
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value.trim()),
      message: i18n.t("validation.the_score_must_be_a_positive_number")
    }
  },
  score: {
    required: true,
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value.trim()),
      message: i18n.t("validation.the_score_must_be_a_positive_number")
    }
  },
  extraPointHonor: {
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value.trim()),
      message: i18n.t("validation.the_score_must_be_a_positive_number")
    }
  },
  extraPointAdvanced: {
    format: {
      valid: value => /^\d{1,255}(\.\d{1,255})?$/.test(value.trim()),
      message: i18n.t("validation.the_score_must_be_a_positive_number")
    }
  }
};

export { validations };
